"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCourseClosed = void 0;
const dayjs = require("dayjs");
const isCourseClosed = (course_closures, start_date, end_date) => {
    if (course_closures.length === 0)
        return {
            closed: false,
            reason: "",
            notes: "",
        };
    // Create an array of dates between start and end date
    const dates = [];
    let current_date = start_date;
    while (current_date <= end_date) {
        dates.push(current_date);
        current_date = dayjs(current_date).add(1, "day").format("YYYY-MM-DD");
    }
    // Check if every date in the range is covered by a closure
    const isClosed = dates.every((date) => {
        return course_closures.some((closure) => {
            // Check if the date falls within the closure date range
            const isInDateRange = dayjs(date).isBetween(closure.start_date, closure.end_date, null, "[]" // inclusive of both start and end dates
            );
            if (!isInDateRange)
                return false;
            // Get the day of the week for this date
            const dayOfWeek = dayjs(date).format("ddd").toLowerCase(); // 'mon', 'tue', etc.
            // Map dayjs format to your closure days format
            const dayMapping = {
                mon: "mon",
                tue: "tue",
                wed: "wed",
                thu: "thu",
                fri: "fri",
                sat: "sat",
                sun: "sun",
            };
            const dayKey = dayMapping[dayOfWeek];
            // Check if this day of the week is included in the closure
            if (dayKey && closure.days[dayKey] === true) {
                return true;
            }
            // You might also want to check for holidays if you have holiday logic
            // For now, we'll ignore the 'hol' field unless you have specific holiday detection
            return false;
        });
    });
    // Get reasons and notes for debugging/info purposes
    const closureDetails = dates.map((date) => {
        const closure = course_closures.find((closure) => {
            const isInDateRange = dayjs(date).isBetween(closure.start_date, closure.end_date, null, "[]");
            if (!isInDateRange)
                return false;
            const dayOfWeek = dayjs(date).format("ddd").toLowerCase();
            const dayMapping = {
                mon: "mon",
                tue: "tue",
                wed: "wed",
                thu: "thu",
                fri: "fri",
                sat: "sat",
                sun: "sun",
            };
            const dayKey = dayMapping[dayOfWeek];
            return dayKey && closure.days[dayKey] === true;
        });
        return {
            date,
            reason: closure?.reason,
            notes: closure?.notes,
            closure_id: closure?.id,
        };
    });
    // Get unique reasons and notes
    const unique_reasons = [
        ...new Set(closureDetails.map((detail) => detail.reason).filter((reason) => reason)),
    ];
    const unique_notes = [
        ...new Set(closureDetails.map((detail) => detail.notes).filter((notes) => notes)),
    ];
    return {
        closed: isClosed,
        reason: isClosed ? unique_reasons.join(", ") : "",
        notes: isClosed ? unique_notes.join(", ") : "",
        // Optional: return detailed breakdown for debugging
        details: closureDetails,
    };
};
exports.isCourseClosed = isCourseClosed;
